import React from 'react';
import { Backdrop, Box, Typography } from '@mui/material';

import CarLoader from './CarLoader';
import storageService from '../../../../services/storage.service';

interface PhotoLoaderProps {
  open: boolean;
  online: boolean;
  progress?: number;
}

const PhotoLoader: React.FC<PhotoLoaderProps> = ({ open, online, progress = 0 }) => {
  const clientColor = storageService.getObject('company')?.color || '#D40020';

  const indeterminate = !online || progress <= 0;
  const message = online
    ? 'Enviando imagem para validação.'
    : 'Salvando imagem...';

  return (
    <Backdrop
      data-testid="photo-loader"
      open={open}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        background: 'rgba(255, 255, 255, 0.95)',
        flexDirection: 'column',
      }}
    >
      <CarLoader progress={progress} indeterminate={indeterminate} color={clientColor} />

      <Box sx={{ textAlign: 'center', marginTop: '40px', padding: '0 20px' }}>
        <Typography
          sx={{ fontWeight: 600, fontSize: '22px', lineHeight: '28px', color: '#262626' }}
        >
          {message}
          {!indeterminate && (
            <>
              <br />
              <span>{progress}%</span>
            </>
          )}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default PhotoLoader;
